module.exports = __webpack_public_path__ + "img/house.e6ece8d0.png";